<template>
  <div class="resetPasswordContent">
    <p>Title: {{ $t('account.common.ResetPasswordContent.content.title') }}</p>
    <p>XXX {{ $t('account.common.ResetPasswordContent.content.hi') }}</p>
    <p>{{ $t('account.common.ResetPasswordContent.content.continue') }}</p>
    <p @click="resetNowFunc" class="resetNow">{{ $t('account.common.ResetPasswordContent.content.reset') }}</p>
    <p>{{ $t('account.common.ResetPasswordContent.content.resetPwd') }}</p>
    <p>{{ $t('account.common.reset.update.team') }}</p>
  </div>
</template>

<script>
export default {
    methods: {
        resetNowFunc () {
            // console.log('resetNow!!')
        }
    }
}
</script>

<style scoped>
p {
    margin: 0px 0px 27px 0px;
}
.resetPasswordContent {
    width: 589px;
    margin: auto;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #333333;
    margin-top: 42px;
}
.resetNow {
    display: inline-block;
    font-weight: 500;
    color: #00b5e2;
    cursor: pointer;
}
</style>
